import { AdminLayout } from '@/components/layouts'
import { useForm } from '@inertiajs/react'
import { UserForm } from './UserForm'

interface Community {
  id: number
  name: string
}

interface NewProps {
  communities: Community[]
  specialties: string[]
  roles: string[]
}

export default function New({ communities, specialties, roles }: NewProps) {
  const { data, setData, post, processing, errors } = useForm({
    pseudo: '',
    first_name: '',
    last_name: '',
    email: '',
    rpps: '',
    specialty: '',
    role: 'member',
    community_id: communities.length > 0 ? String(communities[0].id) : '',
    password: '',
    password_confirmation: '',
    internal_account: false
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/admin/users')
  }

  return (
    <AdminLayout
      title="Nouvel utilisateur"
      breadcrumbs={[
        { label: 'Utilisateurs', href: '/admin/users' },
        { label: 'Nouveau' }
      ]}
    >
      <UserForm
        data={data}
        setData={setData}
        errors={errors}
        processing={processing}
        onSubmit={handleSubmit}
        communities={communities}
        specialties={specialties}
        roles={roles}
        isEdit={false}
      />
    </AdminLayout>
  )
}
